import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TopNav from '../components/TopNav';
import { SpinnerOverlay, InfoPanel } from '../components/index.jsx';
import { getExam } from '../api/exams';
import { useAuth } from '../context/AuthContext';

const styles = `
.hub-page{
  min-height:100vh;
  background:
    radial-gradient(circle at top right, rgba(217,119,6,.08), transparent 24%),
    radial-gradient(circle at top left, rgba(99,102,241,.08), transparent 22%),
    linear-gradient(180deg, #f4f7fb 0%, #f7f9fc 100%);
}
.hub-page .hub-hero{
  background:
    radial-gradient(circle at top right, rgba(245,158,11,.09), transparent 24%),
    radial-gradient(circle at left center, rgba(99,102,241,.10), transparent 22%),
    linear-gradient(135deg, rgba(8,23,44,.96), rgba(14,33,62,.92));
  padding:16px 24px 18px;
  border-bottom:1px solid rgba(255,255,255,.06);
  box-shadow:0 14px 28px rgba(15,23,42,.08);
}
.hub-page .hub-hero-inner{
  max-width:1120px;
  margin:0 auto;
  display:flex;
  flex-direction:column;
  justify-content:center;
}
.hub-page .hub-title{
  color:#fff;
  font-size:32px;
  font-weight:900;
  letter-spacing:-.03em;
  line-height:1.04;
  margin:0;
}
.hub-page .hub-subtitle{
  color:rgba(255,255,255,.74);
  font-size:14px;
  margin-top:6px;
  line-height:1.65;
}
.hub-page .hub-shell{
  max-width:1120px;
  margin:0 auto;
  padding:24px 18px 36px;
}
.hub-page .hub-hint{
  background:linear-gradient(180deg, rgba(255,250,240,.72), rgba(255,255,255,.82));
  border:1px solid rgba(245,158,11,.18);
  border-radius:16px;
  padding:12px 14px;
  margin-bottom:18px;
  display:flex;
  align-items:center;
  gap:12px;
  direction:rtl;
  font-family:'Cairo',sans-serif;
  box-shadow:0 10px 22px rgba(15,23,42,.04);
}
.hub-page .hub-hint-title{
  font-size:13px;
  font-weight:800;
  color:#92400e;
}
.hub-page .hub-hint-copy{
  font-size:12px;
  color:#b45309;
  margin-top:3px;
  line-height:1.65;
}
.hub-page .hub-mock{
  background:
    radial-gradient(circle at top right, rgba(245,158,11,.08), transparent 32%),
    radial-gradient(circle at left center, rgba(99,102,241,.10), transparent 24%),
    linear-gradient(135deg, #0c1d35, #152b4c);
  border-radius:18px;
  margin-bottom:22px;
  border:1px solid rgba(217,119,6,.20);
  overflow:hidden;
  box-shadow:0 26px 54px rgba(15,23,42,.16);
  transition:transform .18s ease, box-shadow .18s ease, border-color .18s ease;
}
.hub-page .hub-mock:hover{
  transform:translateY(-2px);
  box-shadow:0 30px 60px rgba(15,23,42,.18);
  border-color:rgba(217,119,6,.28);
}
.hub-page .hub-mock-main{
  padding:26px 28px;
  cursor:pointer;
}
.hub-page .hub-mock-row{
  display:flex;
  align-items:center;
  justify-content:space-between;
  flex-wrap:wrap;
  gap:20px;
}
.hub-page .hub-mock-copy{
  display:flex;
  align-items:center;
  gap:20px;
}
.hub-page .hub-mock-icon{
  width:58px;
  height:58px;
  background:linear-gradient(135deg,var(--ac),#fbbf24);
  border-radius:16px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:24px;
  flex-shrink:0;
  box-shadow:0 18px 30px rgba(217,119,6,.24);
}
.hub-page .hub-badge{
  display:inline-flex;
  align-items:center;
  gap:6px;
  margin-bottom:10px;
  background:rgba(255,248,235,.90);
  color:#9a3412;
  border:1px solid rgba(251,191,36,.28);
  border-radius:999px;
  padding:6px 10px;
  font-size:10px;
  font-weight:900;
  letter-spacing:.12em;
}
.hub-page .hub-mock-title{
  color:#fff;
  font-size:25px;
  font-weight:900;
  line-height:1.12;
}
.hub-page .hub-mock-desc{
  color:rgba(255,255,255,.76);
  font-size:14px;
  margin-top:5px;
  line-height:1.65;
}
.hub-page .hub-primary{
  min-height:52px;
  padding:0 22px;
  border-radius:14px;
  font-size:15px;
  font-weight:900;
  background:linear-gradient(135deg, var(--ac), #f59e0b);
  box-shadow:0 16px 28px rgba(217,119,6,.20);
  transition:transform .18s ease, box-shadow .18s ease, filter .18s ease;
}
.hub-page .hub-primary:hover{
  transform:translateY(-1px);
  filter:brightness(1.05);
  box-shadow:0 22px 36px rgba(217,119,6,.28);
}
.hub-page .info-btn-light{
  width:100%;
  border:none;
  background:rgba(255,255,255,.05);
  color:rgba(255,255,255,.72);
  padding:11px 18px;
  display:flex;
  align-items:center;
  justify-content:center;
  gap:8px;
  font-size:12px;
  font-weight:800;
  border-top:1px solid rgba(255,255,255,.08);
  transition:background .18s ease,color .18s ease;
}
.hub-page .info-btn-light:hover{
  background:rgba(255,255,255,.12);
  color:#fff;
}
.hub-page .info-panel{
  max-height:0;
  overflow:hidden;
  transition:max-height .28s ease, padding .24s ease, background .24s ease;
}
.hub-page .info-panel.open{
  max-height:420px;
  background:rgba(255,255,255,.04);
}
.hub-page .section-title{
  color:#475569;
  font-size:11px;
  font-weight:900;
  letter-spacing:.18em;
  text-transform:uppercase;
  margin:0 0 12px;
  opacity:.86;
}
.hub-page .hub-skills{
  display:grid;
  grid-template-columns:repeat(3,minmax(0,1fr));
  gap:16px;
}
.hub-page .skill-card{
  background:linear-gradient(180deg,rgba(255,255,255,.98),rgba(249,250,251,.96));
  border-radius:16px;
  border:1px solid rgba(226,232,240,.92);
  overflow:hidden;
  display:flex;
  flex-direction:column;
  min-height:380px;
  box-shadow:0 16px 32px rgba(15,23,42,.06);
  transition:transform .18s ease, box-shadow .18s ease, border-color .18s ease;
}
.hub-page .skill-card:hover{
  transform:translateY(-3px);
  box-shadow:0 22px 42px rgba(15,23,42,.09);
}
.hub-page .skill-card.writing{border-color:rgba(96,165,250,.24)}
.hub-page .skill-card.speaking{border-color:rgba(74,222,128,.24)}
.hub-page .skill-card.reading{border-color:rgba(167,139,250,.24)}
.hub-page .skill-card-body{
  padding:22px 20px 16px;
  flex:1;
}
.hub-page .skill-card-icon{
  width:52px;
  height:52px;
  border-radius:15px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:24px;
  margin-bottom:16px;
}
.hub-page .skill-card.writing .skill-card-icon{background:rgba(59,130,246,.10)}
.hub-page .skill-card.speaking .skill-card-icon{background:rgba(16,185,129,.10)}
.hub-page .skill-card.reading .skill-card-icon{background:rgba(139,92,246,.10)}
.hub-page .hub-skill-title{
  font-size:21px;
  font-weight:900;
  color:#0f172a;
  margin-bottom:10px;
  line-height:1.2;
}
.hub-page .hub-skill-desc{
  font-size:14px;
  color:#475569;
  line-height:1.75;
  margin-bottom:20px;
  min-height:72px;
}
.hub-page .hub-meta{
  display:flex;
  gap:8px;
  flex-wrap:wrap;
}
.hub-page .hub-meta .badge{
  border-radius:999px;
  padding:7px 11px;
  font-size:11px;
  font-weight:800;
  opacity:.96;
}
.hub-page .skill-card-footer{
  padding:14px 18px 18px;
  border-top:1px solid rgba(226,232,240,.92);
  background:rgba(248,250,252,.86);
}
.hub-page .btn-full{
  min-height:50px;
  border-radius:14px;
  font-size:14px;
  font-weight:900;
  box-shadow:0 12px 22px rgba(15,23,42,.08);
  transition:transform .18s ease, box-shadow .18s ease, filter .18s ease;
}
.hub-page .btn-full:hover{
  transform:translateY(-1px);
  filter:brightness(1.04);
  box-shadow:0 16px 28px rgba(15,23,42,.10);
}
.hub-page .skill-card-footer .info-btn-light{
  margin:-14px -18px 14px;
  background:transparent;
  color:#64748b;
  border-top:none;
  border-bottom:1px solid rgba(226,232,240,.92);
}
.hub-page .skill-card-footer .info-btn-light:hover{
  background:rgba(15,23,42,.03);
  color:#0f172a;
}
.hub-page .skill-card-footer .info-panel.open{
  background:transparent;
}
.hub-page .info-row{
  display:flex;
  gap:12px;
  align-items:flex-start;
  margin-bottom:12px;
}
.hub-page .info-icon{
  width:40px;
  height:40px;
  border-radius:12px;
  display:flex;
  align-items:center;
  justify-content:center;
  flex-shrink:0;
}
.hub-page .info-label{
  font-size:12px;
  font-weight:800;
  color:var(--mu);
  margin-bottom:3px;
}
.hub-page .info-val{
  font-size:14px;
  line-height:1.7;
  color:#334155;
}
.hub-page .info-tip{
  display:flex;
  gap:10px;
  align-items:flex-start;
  background:#eff6ff;
  border:1px solid #bfdbfe;
  border-radius:14px;
  padding:12px 14px;
  font-size:13px;
  color:#1e3a8a;
  line-height:1.7;
}
@media (max-width:980px){
  .hub-page .hub-skills{
    grid-template-columns:1fr;
  }
}
@media (max-width:760px){
  .hub-page .hub-hero{
    padding:16px 16px 18px;
  }
  .hub-page .hub-shell{
    padding:18px 14px 30px;
  }
  .hub-page .hub-title{
    font-size:26px;
  }
  .hub-page .hub-mock-main{
    padding:20px 18px;
  }
  .hub-page .hub-mock-title{
    font-size:21px;
  }
}
`;

export default function Hub() {
  const { examId } = useParams();
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [exam, setExam] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hintDismissed, setHintDismissed] = useState(false);

  useEffect(() => {
    getExam(examId).then(setExam).catch(console.error).finally(() => setLoading(false));
  }, [examId]);

  useEffect(() => {
    refreshUser().catch(() => {});
  }, [refreshUser]);

  if (loading) return <><TopNav backTo="/platform" backLabel="All Exams" containerWidth="1120px" /><SpinnerOverlay /></>;
  if (!exam) return <><TopNav backTo="/platform" containerWidth="1120px" /><div style={{ padding: 40, textAlign: 'center' }}>Exam not found</div></>;

  const wQs = exam.questions?.length || 0;
  const sQs = exam.speaking_parts?.length || 0;
  const caps = user?.capabilities || {};
  const openOrUpgrade = (feature, path) => {
    if (caps[feature]) navigate(path);
    else navigate(`/pricing?locked=${feature}`);
  };

  return (
    <div className="hub-page">
      <style>{styles}</style>
      <TopNav
        backTo="/platform"
        backLabel="All Exams"
        containerWidth="1120px"
      />

      <div className="hub-hero">
        <div className="hub-hero-inner">
          <h2 className="hub-title">{exam.title}</h2>
          <p className="hub-subtitle">
            {exam.description} · {exam.time_mins} minutes
          </p>
        </div>
      </div>

      <div className="hub-shell">

        {!hintDismissed && (
          <div className="hub-hint">
            <span style={{ fontSize: 20, flexShrink: 0 }}>💡</span>
            <div style={{ flex: 1 }}>
              <div className="hub-hint-title">اضغط "اعرف أكثر" تحت كل قسم</div>
              <div className="hub-hint-copy">ستجد شرحاً كاملاً بالعربي لما يتوقعك في كل جزء</div>
            </div>
            <button onClick={() => setHintDismissed(true)} style={{ background: 'none', border: 'none', color: '#b45309', fontSize: 18, cursor: 'pointer', flexShrink: 0 }}>×</button>
          </div>
        )}

        <div className="hub-mock">
          <div onClick={() => openOrUpgrade('full_exam', `/exam/${examId}`)} className="hub-mock-main">
            <div className="hub-mock-row">
              <div className="hub-mock-copy">
                <div className="hub-mock-icon">🏆</div>
                <div>
                  <span className="hub-badge">FULL MOCK EXAM</span>
                  <div className="hub-mock-title">Complete Exam Simulation</div>
                  <div className="hub-mock-desc">Writing → Speaking → Reading · Full report</div>
                </div>
              </div>
              <button className="btn btn-gold hub-primary" onClick={(e) => { e.stopPropagation(); openOrUpgrade('full_exam', `/exam/${examId}`); }}>
                {caps.full_exam ? 'Start Full Exam →' : 'Upgrade to unlock →'}
              </button>
            </div>
          </div>
          <InfoPanel id="fe">
            <div style={{ color: 'var(--ac)', fontSize: 13, fontWeight: 700, marginBottom: 12 }}>🏆 الاختبار الكامل</div>
            <div className="info-row"><div className="info-icon" style={{ background: 'rgba(217,119,6,.15)' }}>🔄</div><div><div className="info-label" style={{ color: 'rgba(255,255,255,.4)' }}>الترتيب</div><div className="info-val" style={{ color: 'rgba(255,255,255,.8)' }}>✍️ كتابة ← 🎙 محادثة ← 📖 قراءة</div></div></div>
            <div className="info-row"><div className="info-icon" style={{ background: 'rgba(217,119,6,.15)' }}>🏅</div><div><div className="info-label" style={{ color: 'rgba(255,255,255,.4)' }}>النتيجة</div><div className="info-val" style={{ color: 'rgba(255,255,255,.8)' }}>تقرير شامل بمستواك الكلي B1+ / B1 / A2</div></div></div>
            <div className="info-tip"><span>💡</span><span>لا تتوقف بين الأجزاء — هذا سرّ المحاكاة الحقيقية.</span></div>
          </InfoPanel>
        </div>

        <p className="section-title">Or practise a single skill</p>
        <div className="hub-skills">

          <div className="skill-card writing">
            <div className="skill-card-body">
              <div className="skill-card-icon">✍️</div>
              <div className="hub-skill-title">Writing Test</div>
              <div className="hub-skill-desc">Email, article and story tasks. Official Cambridge B1 rubric marking.</div>
              <div className="hub-meta">
                <span className="badge badge-blue">{wQs} questions</span>
                <span className="badge badge-gray">{exam.time_mins} min</span>
                <span className="badge badge-green">20 marks</span>
              </div>
            </div>
            <InfoPanel id="wr">
              <div className="info-row"><div className="info-icon" style={{ background: '#dbeafe' }}>📄</div><div><div className="info-label">ماذا ستكتب</div><div className="info-val"><strong>الجزء 1 (إلزامي):</strong> إيميل · <strong>الجزء 2:</strong> مقالة أو قصة</div></div></div>
              <div className="info-row"><div className="info-icon" style={{ background: '#dbeafe' }}>📊</div><div><div className="info-label">التقييم</div><div className="info-val">المحتوى · الأسلوب · التنظيم · اللغة (5×4=20)</div></div></div>
              <div className="info-tip"><span>💡</span><span>أجب على جميع النقاط. الإجابة الناقصة تخسر درجات.</span></div>
            </InfoPanel>
            <div className="skill-card-footer">
              {wQs > 0
                ? <button className="btn btn-primary btn-full" onClick={() => openOrUpgrade('writing', `/writing/${examId}`)}>{caps.writing ? 'Begin Writing Test →' : 'Upgrade to unlock →'}</button>
                : <p style={{ textAlign: 'center', color: 'var(--mu)', fontSize: 13 }}>No questions added yet</p>
              }
            </div>
          </div>

          <div className="skill-card speaking">
            <div className="skill-card-body">
              <div className="skill-card-icon">🎙</div>
              <div className="hub-skill-title">Speaking Test</div>
              <div className="hub-skill-desc">AI examiner speaks aloud. You answer with your microphone.</div>
              <div className="hub-meta">
                <span className="badge badge-teal">{sQs} parts</span>
                <span className="badge badge-gray">~15 min</span>
                <span className="badge badge-green">15 marks</span>
              </div>
            </div>
            <InfoPanel id="sp">
              <div className="info-row"><div className="info-icon" style={{ background: '#d1fae5' }}>🔢</div><div><div className="info-label">الأجزاء</div><div className="info-val">مقابلة · وصف صور · نقاش · آراء</div></div></div>
              <div className="info-row"><div className="info-icon" style={{ background: '#d1fae5' }}>🎤</div><div><div className="info-label">كيف يعمل</div><div className="info-val">اضغط الميكروفون وتحدث بشكل طبيعي</div></div></div>
              <div className="info-tip" style={{ background: '#f0fdf4', borderColor: '#bbf7d0', color: '#065f46' }}><span>💡</span><span>تحدث بجمل كاملة. لا تقل "نعم" أو "لا" فقط.</span></div>
            </InfoPanel>
            <div className="skill-card-footer">
              {sQs > 0
                ? <button className="btn btn-teal btn-full" onClick={() => openOrUpgrade('speaking', `/speaking/${examId}`)}>{caps.speaking ? 'Begin Speaking Test →' : 'Upgrade to unlock →'}</button>
                : <p style={{ textAlign: 'center', color: 'var(--mu)', fontSize: 13 }}>No speaking questions yet</p>
              }
            </div>
          </div>

          <div className="skill-card reading">
            <div className="skill-card-body">
              <div className="skill-card-icon">📖</div>
              <div className="hub-skill-title">Reading Test</div>
              <div className="hub-skill-desc">Six parts: signs, matching, true/false, article, cloze.</div>
              <div className="hub-meta">
                <span className="badge badge-purple">6 parts</span>
                <span className="badge badge-gray">45 min</span>
                <span className="badge badge-green">33 marks</span>
              </div>
            </div>
            <InfoPanel id="rd">
              <div className="info-row"><div className="info-icon" style={{ background: '#ede9fe' }}>📋</div><div><div className="info-label">الأجزاء</div><div className="info-val">إشعارات · مطابقة · صح/خطأ · فهم مقال · ملء اختيار · ملء مفتوح</div></div></div>
              <div className="info-tip" style={{ background: '#faf5ff', borderColor: '#ddd6fe', color: '#5b21b6' }}><span>💡</span><span>اقرأ الأسئلة أولاً ثم ارجع للنص.</span></div>
            </InfoPanel>
            <div className="skill-card-footer">
              <button className="btn btn-purple btn-full" onClick={() => openOrUpgrade('reading', `/reading/${examId}`)}>{caps.reading ? 'Start Reading Test →' : 'Upgrade to unlock →'}</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
